import React, { FC } from "react";
import FadeBackgroundWrapper from "../../../../../../../features/Common/modules/Comments/modules/FadeBackgroundWrapper/FadeBackgroundWrapper";

export const HighlightedCommentWrapper: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <FadeBackgroundWrapper Component="tr" enableFade={true}>
      {children}
    </FadeBackgroundWrapper>
  );
};
